module.exports = __webpack_public_path__ + "img/375_news_sub_img4.1d56e836.png";